module.exports = __webpack_public_path__ + "static/media/Regulamin.2b5b6003.pdf";